import { render, staticRenderFns } from "./DetaliiOferta.vue?vue&type=template&id=1fc2b023&scoped=true"
import script from "./DetaliiOferta.vue?vue&type=script&lang=js"
export * from "./DetaliiOferta.vue?vue&type=script&lang=js"
import style0 from "./DetaliiOferta.vue?vue&type=style&index=0&id=1fc2b023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2b023",
  null
  
)

export default component.exports